export default "__VITE_ASSET__DTMz0CWq__"